import React, { useContext } from 'react';
import { Checkbox, IconCards, dlsBrightBlue } from '@americanexpress/dls-react';
import userContext from '../../components/ContextComponent/UserContext';

function AdditionalCard() {
    const { formData, setFormData } = useContext(userContext);
    const valueChange = (e) => {
        setFormData({ ...formData, additionalCard: e.target.checked });
    }
    return (
        <>
            <div>
                <div className="flex margin-2-t">
                    <IconCards theme={dlsBrightBlue} filled={true} title="accessibility icon" size="md" />
                    <h2 className="heading-3 margin-1-l">Additional Card</h2>
                </div>
            </div>
            <div>
                <div className="margin-1-t">
                    <Checkbox
                        id="AdditionalCard"
                        label="Yes, I want to apply for an Additional Card to separate different categories of expenditure."
                        aria-labelledby=""
                        value={true}
                        onChange={valueChange}
                    />
                </div>
            </div>
        </>
    );
}
export default AdditionalCard;